export const SET_ARTICLES = "SET_ARTICLES";

export default {
  [SET_ARTICLES]: (state, articlesData) => {
    state.articlesData = articlesData;
  },
};
